/**
 * Composants Material Design 3 utilisés par l'application.
 * Importés une seule fois, pour que le navigateur n'enregistre que le
 * nécessaire. Aucune icône distante : les symboles sont des caractères.
 */

import '@material/web/button/filled-button.js';
import '@material/web/button/filled-tonal-button.js';
import '@material/web/button/outlined-button.js';
import '@material/web/button/text-button.js';
import '@material/web/iconbutton/icon-button.js';
import '@material/web/iconbutton/filled-tonal-icon-button.js';
import '@material/web/ripple/ripple.js';
import '@material/web/textfield/outlined-text-field.js';
import '@material/web/textfield/filled-text-field.js';
import '@material/web/progress/linear-progress.js';
import '@material/web/divider/divider.js';
import '@material/web/checkbox/checkbox.js';

/** Valeur d'un champ Material ou natif, sans dépendre de son type exact. */
export function valeurDe(evenement: Event): string {
  const cible = evenement.target as (HTMLElement & { value?: string }) | null;
  return cible?.value ?? '';
}

/** Élément coché d'une case Material ou native. */
export function cocheDe(evenement: Event): boolean {
  const cible = evenement.target as (HTMLElement & { checked?: boolean }) | null;
  return cible?.checked ?? false;
}
